import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useTheme } from "@emotion/react";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 470,
  height: 350,
  boxShadow: 24,
  p: 0,
};

const CustomModal = ({
  open,
  handleClose,
  title = null,
  description,
  children,
  customstyle,
}) => {
  const theme = useTheme();
  return (
    <Modal
      open={open}
      onClose={handleClose}
      style={{ backdropFilter: "blur(3px)" }}
    >
      <Box
        sx={{
          ...modalStyle,
          ...customstyle,
          backgroundColor: theme.palette.fieldFill.main,
          border: `1px solid ${theme.palette.button.main}`,
          borderRadius: "8px",
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ width: "100%", height: "100%" }}>
          {title && (
            <>
              <Typography
                id="modal-title"
                variant="p"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: theme.palette.white.main,
                  height: "15%",
                  textAlign: "center",
                  minHeight: "50px",
                }}
              >
                {title}
              </Typography>{" "}
              <hr
                color={`${theme.palette.button.main}`}
                size="1"
                style={{ margin: "0px 10px" }}
              />
            </>
          )}
          <Box
            sx={{
              width: "100%",
              height: `${title? '85%' : '100%'}`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default CustomModal;
